// @ts-nocheck
/**
 * FXペア（属性レート）定義
 * 2属性間の価格比率に投資するシステム
 */

// 属性定義
export const ATTRIBUTES = ['炎', '水', '光', '闇', '原始', '未来'];

// 属性アイコン
export const ATTRIBUTE_ICONS = {
  '炎': '🔥',
  '水': '💧',
  '光': '✨',
  '闇': '🌙',
  '原始': '🌿',
  '未来': '⚙️',
};

// 属性ボラティリティ（価格変動の激しさ）
export const ATTRIBUTE_VOLATILITY = {
  '光': 0.7,    // 低 - 聖域は安定
  '水': 0.8,    // やや低 - 海流は緩やか
  '炎': 1.0,    // 標準 - 火山で時々急変
  '原始': 1.1,  // やや高 - 繁殖期で変動
  '闇': 1.4,    // 高 - 魔女の呪いで予測困難
  '未来': 1.6,  // 最高 - 時空の歪みで不安定
};

// FXペア定義（15種類）
export const FX_PAIRS = {
  FIRE_WATER: {
    id: 'FIRE_WATER',
    base: '炎',
    quote: '水',
    symbol: '🔥/💧',
    name: '炎/水レート',
  },
  FIRE_LIGHT: {
    id: 'FIRE_LIGHT',
    base: '炎',
    quote: '光',
    symbol: '🔥/✨',
    name: '炎/光レート',
  },
  FIRE_DARK: {
    id: 'FIRE_DARK',
    base: '炎',
    quote: '闇',
    symbol: '🔥/🌙',
    name: '炎/闇レート',
  },
  FIRE_PRIMITIVE: {
    id: 'FIRE_PRIMITIVE',
    base: '炎',
    quote: '原始',
    symbol: '🔥/🌿',
    name: '炎/原始レート',
  },
  FIRE_FUTURE: {
    id: 'FIRE_FUTURE',
    base: '炎',
    quote: '未来',
    symbol: '🔥/⚙️',
    name: '炎/未来レート',
  },
  WATER_LIGHT: {
    id: 'WATER_LIGHT',
    base: '水',
    quote: '光',
    symbol: '💧/✨',
    name: '水/光レート',
  },
  WATER_DARK: {
    id: 'WATER_DARK',
    base: '水',
    quote: '闇',
    symbol: '💧/🌙',
    name: '水/闇レート',
  },
  WATER_PRIMITIVE: {
    id: 'WATER_PRIMITIVE',
    base: '水',
    quote: '原始',
    symbol: '💧/🌿',
    name: '水/原始レート',
  },
  WATER_FUTURE: {
    id: 'WATER_FUTURE',
    base: '水',
    quote: '未来',
    symbol: '💧/⚙️',
    name: '水/未来レート',
  },
  LIGHT_DARK: {
    id: 'LIGHT_DARK',
    base: '光',
    quote: '闇',
    symbol: '✨/🌙',
    name: '光/闇レート',
  },
  LIGHT_PRIMITIVE: {
    id: 'LIGHT_PRIMITIVE',
    base: '光',
    quote: '原始',
    symbol: '✨/🌿',
    name: '光/原始レート',
  },
  LIGHT_FUTURE: {
    id: 'LIGHT_FUTURE',
    base: '光',
    quote: '未来',
    symbol: '✨/⚙️',
    name: '光/未来レート',
  },
  DARK_PRIMITIVE: {
    id: 'DARK_PRIMITIVE',
    base: '闇',
    quote: '原始',
    symbol: '🌙/🌿',
    name: '闇/原始レート',
  },
  DARK_FUTURE: {
    id: 'DARK_FUTURE',
    base: '闇',
    quote: '未来',
    symbol: '🌙/⚙️',
    name: '闇/未来レート',
  },
  PRIMITIVE_FUTURE: {
    id: 'PRIMITIVE_FUTURE',
    base: '原始',
    quote: '未来',
    symbol: '🌿/⚙️',
    name: '原始/未来レート',
  },
};

// ペアボラティリティ計算
export function getPairVolatility(pairId) {
  const pair = FX_PAIRS[pairId];
  if (!pair) return 1.0;

  const baseVola = ATTRIBUTE_VOLATILITY[pair.base] || 1.0;
  const quoteVola = ATTRIBUTE_VOLATILITY[pair.quote] || 1.0;
  return (baseVola + quoteVola) / 2;
}

// リスク分類判定
export function getRiskCategory(pairVolatility) {
  if (pairVolatility <= 0.80) {
    return {
      level: '超安定',
      stars: '★☆☆☆☆',
      maxLeverage: 25,
      warning: false,
    };
  }
  if (pairVolatility <= 0.95) {
    return {
      level: '安定',
      stars: '★★☆☆☆',
      maxLeverage: 20,
      warning: false,
    };
  }
  if (pairVolatility <= 1.15) {
    return {
      level: '標準',
      stars: '★★★☆☆',
      maxLeverage: 10,
      warning: false,
    };
  }
  if (pairVolatility <= 1.35) {
    return {
      level: '高変動',
      stars: '★★★★☆',
      maxLeverage: 5,
      warning: true,
    };
  }
  return {
    level: '激変',
    stars: '★★★★★',
    maxLeverage: 2,
    warning: true,
  };
}

// ペア情報取得ヘルパー
export function getFXPair(pairId) {
  return FX_PAIRS[pairId] || null;
}

// 全ペア一覧取得
export function getAllFXPairs() {
  return Object.values(FX_PAIRS);
}

// ペア一覧（詳細情報付き）
export function getFXPairsWithDetails() {
  return Object.values(FX_PAIRS).map((pair) => {
    const volatility = getPairVolatility(pair.id);
    const risk = getRiskCategory(volatility);
    return {
      ...pair,
      volatility,
      ...risk,
    };
  });
}
